// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Meta from 'vue-meta'
import VueRouter from 'vue-router'

/*Pages*/
import Onama from './components/Onama.vue'
import Home from './components/Home.vue'
import Galerija from './components/Galerija.vue'
import Video from './components/Video.vue'
import Oprema from './components/Oprema.vue'
import Kontakt from './components/Kontakt.vue'
import PolicaPrivatnosti from './components/PolicaPrivatnosti.vue'
import PageNotFound from './components/shared/404.vue'

import AOS from 'aos';
import 'aos/dist/aos.css'
import './assets/style/main.scss'

//Scroll to
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

//mobile touch events
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents, {
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 20,
  longTapTimeInterval: 400
})

//lazy load
import VueLoadImage from 'vue-load-image'
Vue.component('vue-load-image', VueLoadImage);

//Vue Meta
import VueMeta from 'vue-meta'
Vue.use(VueMeta,  {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})


Vue.use(VueRouter);
Vue.use(Meta);
Vue.directive('aos', AOS);

/* Header & Footer */
import Header from './components/shared/Header.vue';
import Footer from './components/shared/Footer.vue';
Vue.component('app-header', Header)
Vue.component('app-footer', Footer)
/******************/

Vue.config.productionTip = false

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'S light production, najam koncertne opreme, rasvjeta za vjenčanja',      
      metaTags: [
        {
          name: 'description',
          content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
        },
        {
          property: 'og:description',
          content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
        }
      ]
    }      
  },  
  {
      path: '/onama', name: 'onama', 
      component: Onama,
      meta: {
        title: 'S light production - obratite nam se sa povjerenjem',
        metaTags: [
          {
            name: 'description',
            content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
          },
          {
            property: 'og:description',
            content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
          }
        ]
      }             
  },    
  {
    path: '/galerija',
    name: 'galerija', 
    component: Galerija,
    meta: {
      auth: true,
      title: 'S light production - foto galerija vjenčanja, koncerata i događaja',      
      metaTags: [
        {
          name: 'description',
          content: 'S Light Production foto galerija: vjenčanje, koncert i događaj. Najam rasvjete, organizacija događaja. Višegodišnje iskustvo.'
        },
        {
          property: 'og:description',
          content: 'S Light Production foto galerija: vjenčanje, koncert i događaj. Najam rasvjete, organizacija događaja. Višegodišnje iskustvo.'
        }
      ]
    }     
  },    
  {
    path: '/video',
    name: 'video',
    component: Video,
    meta: {
      title: 'S light production - video galerija vjenčanja, koncerata i događaja',      
      metaTags: [
        {
          name: 'description',
          content: 'S Light Production video galerija: vjenčanje, koncert i događaj. Najam rasvjete, organizacija događaja. Višegodišnje iskustvo.'
        },
        {
          property: 'og:description',
          content: 'S Light Production video galerija: vjenčanje, koncert i događaj. Najam rasvjete, organizacija događaja. Višegodišnje iskustvo.'
        }
      ]
    }     
  },    
  {
    path: '/oprema',
    name: 'oprema',
    component: Oprema,
    meta: {
      title: 'S light production, najam koncertne opreme, rasvjeta za vjenčanja',      
      metaTags: [
        {
          name: 'description',
          content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
        },
        {
          property: 'og:description',
          content: 'S Light Production profesionalna je tvrtka s višegodišnjim iskustvom i stručnim timom koja nudi cjelokupnu organizaciju svih Vaših događaja.'
        }
      ]
    }     
  },    
  {
    path: '/kontakt',
    name: 'kontakt', 
    component: Kontakt,
    meta: {
      title: 'S light production - Kontakt - najam koncertne opreme, rasvjeta za vjenčanja',      
      metaTags: [
        {
          name: 'description',
          content: 'S Light Production, kontaktirajte nas s povjerenjem. Profesionalna tvrtka s višegodišnjim iskustvom i stručnim timom. Organizacija događaja.'
        },
        {
          property: 'og:description',
          content: 'S Light Production, kontaktirajte nas s povjerenjem. Profesionalna tvrtka s višegodišnjim iskustvom i stručnim timom. Organizacija događaja.'
        }
      ]
    }      
  },  
  {path: '/polica-privatnosti', name: 'polica-privatnosti', component: PolicaPrivatnosti},  
  {path: '/404', component: PageNotFound },  
  {path: '*', component: PageNotFound }
];

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },  
  routes,
  mode: 'history',
  base: "/"
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});
/*******************Gloabal Variables***************************/
Vue.prototype.dataPath = 'https://slightproduction.hr/';
Vue.prototype.apiPath = 'https://slightproduction.hr/api/';

// Vue.prototype.dataPath = 'http://localhost/slightproduction/';
// Vue.prototype.apiPath = 'http://localhost/slightproduction/api/';

//SOCIAL NETWORK LINKS
// Vue.prototype.instagramUrl = 'https://www.instagram.com/bymedproduction/?hl=en';
Vue.prototype.facebookUrl = 'https://www.facebook.com/slightproduction';
Vue.prototype.youtubeUrl = 'https://www.youtube.com/channel/UCt0VzwsNXbOp7b1Nl9SrXyA/videos';
/***************************************************************/

new Vue({
  el: '#app',
  router,
  created() {
    AOS.init();
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js